import React, { useEffect }  from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Select } from 'antd';
import { fetchBaseInfo } from '@/Actions/Baseinfo';
import { ordersStatusPayed as defaultSearchStatus } from '@/Libs/Orders';

const Option = Select.Option;

export default (props) => {
  const dispatch = useDispatch();
  const ordersStatus = useSelector((state) => state.get('Baseinfo').get('orders_status')) || [];
  useEffect(() => {
    if (ordersStatus.length === 0) dispatch(fetchBaseInfo('orders_status'));
    return () => {};
  }, [ordersStatus]);
  return (
    <>
      <Select
        labelInValue={true}
        dropdownMatchSelectWidth={false}
        allowClear={true}
        mode={'multiple'}
        maxTagCount={props?.maxTagCount || 0}
        maxTagPlaceholder={(omittedValues) => ` + ${omittedValues.length} 更多...`}
        {...props}
      >
        {ordersStatus.map((ele) => (
          <Option value={ele.key} key={ele.key}>
            {ele.prefix}-{ele.label}
          </Option>
        ))}
      </Select>
    </>
  );
}
